/**************************************************************************************************/
/*   File: /src/app/stores/states/authorization/state.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday February 18th 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromShared from '../../../shared';

/**
 * The authorization state
 */
export interface AuthorizationState {
  /**
   * The messages
   */
  messages: fromShared.models.Message[];
  /**
   * is loading
   */
  isLoading: boolean;
  /**
   * The is authorized flag: true means that frontend user is authorized
   */
  isAuthorized: boolean;
  /**
   * Is authorizing
   */
  isAuthorizing: boolean;
  /**
   * Is revoked
   */
  isRevoked: boolean;
  /**
   * Is rejected
   */
  isRejected: boolean;
  /**
   * Files for authorizations
   */
  files: Array<fromShared.models.FileModel>;
  /**
   * The upload is finished
   */
  uploadFinished: boolean;

}

/**
 * The initial authorization state
 */
export const INITIAL_AUTH_STATE: AuthorizationState = {
  messages: [],
  isLoading: false,
  isAuthorized: false,
  isAuthorizing: false,
  isRevoked: false,
  isRejected: false,
  files: [],
  uploadFinished: false
};

/**
 * The state name
 */
export const STATE_NAME = 'authorization';